import pluralize from 'pluralize'

import {
  hasStatementFailed,
  isStatementNotDuplicated,
  isStatementToStart,
} from '@/modules/projects/status'
import type { Statement } from '@/modules/projects/stores'

export const processButtonLabel = (statements: Statement[]) => {
  const startable = statements
    .filter(isStatementNotDuplicated)
    .filter(isStatementToStart)
  if (startable.length === 0) return 'Process statements'

  const failed = startable.filter(hasStatementFailed)
  if (failed.length === startable.length) {
    return `Retry ${failed.length} failed`
  }

  const pages = startable.reduce(
    (sum, statement) => sum + statement.numberOfPages,
    0,
  )
  return `Process ${startable.length} ${pluralize('file', startable.length)} · ${pages} ${pluralize('page', pages)}`
}
